import styled from 'styled-components';

import Form from './Form';
import Title from './Title';
import Option from './Option';
import Circle from './Circle';
import Image from './Image';

const Container = styled.div``;

Container.Form = Form;
Container.Title = Title;
Container.Option = Option;
Container.Circle = Circle;
Container.Image = Image;

export default Container;
